import React, { useState } from 'react';
import { toast } from 'react-toastify';

import useGetMe from '../../hooks/useCurrentUser';
import { BaseService } from '../../global/classes';
import GoogleReviewModal from '../GoogleReviewModal';

import NpsSurveyModal from './npsSurveyModal';
import { NpsAnswerService } from './services/NpsAnswerService';
import { NpsEligibility } from './types';
import { isPromoterScore } from './scores';

interface NpsSurveyContainerProps {
  eligibility: NpsEligibility;
  onClose(): void;
}

const npsAnswerService = new NpsAnswerService();

const NpsSurveyContainer: React.FC<NpsSurveyContainerProps> = ({ eligibility, onClose }) => {
  const user = useGetMe();

  const [submitting, setSubmitting] = useState(false);
  const [showGoogleReview, setShowGoogleReview] = useState(false);

  const { npsConfigurationId, question } = eligibility;
  const businessId = new BaseService().selectedCompany?.id;

  if (!npsConfigurationId || !question || !businessId) return null;

  const answer = { npsConfigurationId, businessId, userId: user?.id };

  const handleSubmit = async (score: number, comment: string) => {
    setSubmitting(true);

    try {
      await npsAnswerService.createAnswer({ ...answer, score, comment: comment || undefined });

      if (isPromoterScore(score)) {
        setShowGoogleReview(true);
        return;
      }

      toast.success('Obrigado pela sua avaliação!');
      onClose();
    } catch {
      toast.error('Não foi possível enviar sua avaliação. Tente novamente.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleDismiss = async () => {
    await npsAnswerService.createDismissal(answer).catch((error) => console.log(error));
    onClose();
  };

  if (showGoogleReview) return <GoogleReviewModal visible onClose={onClose} />;

  return (
    <NpsSurveyModal
      visible
      question={question}
      onClose={handleDismiss}
      onDismiss={handleDismiss}
      onSubmit={handleSubmit}
      submitting={submitting}
    />
  );
};

export default NpsSurveyContainer;
